import { ThemeUIStyleObject } from 'theme-ui';

export const headerContainerStyles: ThemeUIStyleObject = {
  bg: 'neutral/000',
  borderBottom: '1px solid',
  borderColor: 'neutral/300',
  px: ['1rem', '5rem'],
  height: ['3.5rem', '4rem'],
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  position: 'sticky',
  top: 0,
  zIndex: 100,
};

export const leftSectionStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  gap: ['1rem', '2rem'],
  flex: 1,
};

export const rightSectionStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: ['0.5rem', '1rem'],
};
